import { captureMessage } from '@sentry/react'

/**
 * Sentry reporting for the always-on SSE screens. The server-side checker owns
 * the FACT "station offline" (Telegram alert — absence is only observable from
 * the server); this module owns the WHY, reported from the one place that can
 * see it: the recovering client. One report per outage — the retry loop runs
 * every minute forever and must not flood Sentry.
 */

export type SseDegradedReason =
    | 'unauthorized'
    | 'timeout'
    | 'network'
    | 'stream_stall_loop'

interface DegradedInfo {
    reason: SseDegradedReason
    retries: number
}

let outageReportedAt: number | null = null

export function reportSseDegraded(info: DegradedInfo): void {
    if (outageReportedAt !== null) return
    outageReportedAt = Date.now()
    captureMessage(`sse degraded: ${info.reason}`, {
        level: 'error',
        tags: { sse_reason: info.reason },
        extra: { retries: info.retries },
    })
}

export function reportSseRecovered(): void {
    if (outageReportedAt === null) return
    const outageMs = Date.now() - outageReportedAt
    outageReportedAt = null
    captureMessage('sse recovered', {
        level: 'info',
        extra: { outage_ms: outageMs },
    })
}

export function resetSseHealthForTests(): void {
    outageReportedAt = null
}
